import { render, staticRenderFns } from "./verify.vue?vue&type=template&id=048f3e64&scoped=true&"
import script from "./verify.vue?vue&type=script&lang=js&"
export * from "./verify.vue?vue&type=script&lang=js&"
import style0 from "./verify.vue?vue&type=style&index=0&id=048f3e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048f3e64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
